var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
$(window).on("resize", function(){
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
$(function(){
  console.log("form2.js"); 
    
  /* ==================================== 초기UI 실행 호출함수 호출  ==================================== */
  window.PubFORM = new PubFORM();
  window.PubFORM.placeholderIe9();
  window.PubFORM.inputDelSet();    // input 삭제
  window.PubFORM.inputSearchDel(); // 검색어 팝업
  window.PubFORM.select2Set();
  window.PubFORM.scrollbaroverlaySet();
  window.PubFORM.datepickerSet();
  window.PubFORM.tooltipSet();

});


/* ==================================== 초기UI 실행 함수 호출  ==================================== */
function PubFORM() {
  var _this = this;

  /* ie9 placeholder */
  _this.placeholderIe9 = function() {  
    $('input, textarea').placeholder({customClass:'my-placeholder'});
  }

  /* input Del set */
  _this.inputDelSet = function() {  
    function inputdel_fn($this) {
      var _noneDisable = !$this.prop("disabled");
      if( $this.val() != "" && _noneDisable){
        $this.siblings("button").css({display:"block"});
        $this.siblings("button").one("click", function(){
          $this.val("");
          $this.siblings("button").css({display:"none"});
        });
      }else{
        $this.siblings("button").css({display:"none"});
      }
    }
    $("body").off("focusout", ".input_del input");
    $("body").on("focusout", ".input_del input", function($e){
      inputdel_fn( $(this) );
    });
    $("body .input_del input").each(function($e){
      inputdel_fn( $(this) );
    });
  }

  /* input Search Del */
  _this.inputSearchDel = function() {  
    function inputdel_fn($this) {
      var _noneDisable = !$this.prop("disabled");
      if( $this.val() != "" && _noneDisable){
        $this.siblings(".btn_del").css({display:"block"});
        $this.siblings(".btn_del").one("click", function(){
          $this.val("");
          $this.siblings(".btn_del").css({display:"none"});
          inputsmart_fn($this);
        });
      }else{
        $this.siblings(".btn_del").css({display:"none"});
      }
    }
    function inputsmart_fn($this) {
      if($this.val()){ 
        $this.closest(".js-search-area").find(".search_smart-box").addClass("open");
      }else{
        $this.closest(".js-search-area").find(".search_smart-box").removeClass("open");
      }
    }

    $("body").off("focusout keyup", ".input_search_del input");
    $("body").on("focusout keyup", ".input_search_del input", function($e){
      inputdel_fn( $(this) );
    });
    $(".input_search_del input").each(function($e){
      inputdel_fn( $(this) );
    });
    
    $(".input_search_del input").on("keyup" , function($e){
      inputsmart_fn( $(this) )
    });
  }

  /* select2 set*/
  _this.select2Set = function(){
    /* 선택박스 */
    $(".select2Basic").select2({            
      minimumResultsForSearch: Infinity,
      /*theme: "basic"*/
    });
    // 팝업 선택박스 index 높이기
    $(".select2Basic_pop").select2({   
      dropdownCssClass : 'increasedzindexclass_pop',
      minimumResultsForSearch: Infinity,
      width:"100%" 
    });
  }

  /* 스크롤바 overlayScrollbars */
  _this.scrollbaroverlaySet = function(){
    $(".js-ol_scrollbarY").overlayScrollbars({ }).overlayScrollbars();
    $(".js-ol_scrollbarX").overlayScrollbars({ }).overlayScrollbars();
  }

  /* 켈린터  */
  _this.datepickerSet = function(){
    $(".js-datepicker").datepicker({ 
      dateFormat: "yy-mm-dd", 
      showMonthAfterYear:true,
      //yearSuffix: "년",
      dayNames: ["S","M","T","W","T","F","S"]
    });

    /* 연 달력 */
    $('.js-datepicker-yyyy').datepicker({
        dateFormat: "yy",
        yearRange: "c-100:c",
        changeMonth: false,
        changeYear: true,
        showButtonPanel: false,
        closeText:'Select',
        currentText: 'This year',
        onClose: function(dateText, inst) {
            var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
            $(this).val($.datepicker.formatDate("yy", new Date(year, 0, 1)));
        },
        beforeShow: function(input, inst){
            if ($(this).val()!=''){
            var tmpyear = $(this).val();
            $(this).datepicker('option','defaultDate',new Date(tmpyear, 0, 1));
            }
        }
    }).focus(function () {
        $(".ui-datepicker-month").hide();
        $(".ui-datepicker-calendar").hide();
        $(".ui-datepicker-current").hide();
        $(".ui-datepicker-prev").hide();
        $(".ui-datepicker-next").hide();
        $("#ui-datepicker-div").position({
          my: "left top",
          at: "left bottom",
          of: $(this)
      });
    }).attr("readonly", true);

    /* 월 달력 */
    $(".js-datepicker-yy_mm").monthPicker();
  }

  /* 툴팁 */
  _this.tooltipSet = function(){
    
    /* 일반 툴팁 */
    $(".js-tooltip").tooltip({ 
      position: { 
        my: "center bottom-15",
        at: "center top",
        using: function( position, feedback ) {
          $( this ).css( position );
          $( "<div>" ).addClass( "arrow" ).addClass( feedback.vertical ).addClass( feedback.horizontal ).appendTo( this ); 
        }
      }
    });//.tooltip( "open" );

  
    /* 길설명 툴팁 */
    $(".js-tooltip_sendstate").tooltip({ 
      position: { 
        my: "center bottom-10",
        at: "center top",
        using: function( position, feedback ) {
          $( this ).css( position );
          var _dotL = feedback.target.left - position.left + 6; 
          $( "<div>" ).addClass( "arrow" ).addClass( feedback.vertical ).addClass( feedback.horizontal ).appendTo( this ).css({ left: _dotL });
        }
      },
      tooltipClass:"tooltip_big",
      items: "img, [data-geo], [title]",
      content: function() {
        var element = $( this );
        var selcet = $( this ).attr("data-geo");
        if ( element.is( "[data-geo]" ) ) {
            $(".ui-tooltip").css({"max-width":"500px;" });
            return $(selcet).html();
        }
        if ( element.is( "[title]" ) ) {
            return element.attr( "title" );
        }
        if ( element.is( "img" ) ) {
            return element.attr( "alt" );
        }
      }   
    });//.tooltip( "open" );       

  }

}

